export default __webpack_public_path__ + "static/media/supportIcon.5560bb4e.svg";